import { defineStore } from 'pinia';
import { useStoreSsPlayer } from '../softswiss/player';
import { useStoreCurrencyMenu } from '../strapi/currencyMenu';

export const useStoreInGameCurrencyExchange = defineStore('InGameCurrencyExchange', {
  state: () => ({
    isIngameCurrencyExchangeEnabled: true,
    selectedCurrency: null as string | null,
  }),
  getters: {
    isAvailableCurrencyExchange(): boolean {
      const storeSsPlayer = useStoreSsPlayer();
      const storeCurrencyMenu = useStoreCurrencyMenu();

      return (
        this.isIngameCurrencyExchangeEnabled &&
        storeSsPlayer.isPlayerAuthorised &&
        storeCurrencyMenu.isCryptoCurency(storeSsPlayer.playerCurrency || '')
      );
    },
  },
  actions: {
    setCurrency(currency: string) {
      this.selectedCurrency = currency;
    },
    removeSelectedCurrency() {
      this.selectedCurrency = null;
    },
  },
});
